export default "__VITE_ASSET__CeZxC36u__"